module.exports = __webpack_public_path__ + "img/hops.b71ffab6.png";